<template>
<div>
  <search-list
    @findData="findData"
    :projectList = "projectList"
    :empTypeList="empTypeList"
    :isProjectManager="isProjectManagerList"
  ></search-list>
  <div class="page-wrapper">
  <table-list

      :columns="columns"
      :data="tableData"
      :total="total"
      :current="current"
      :loading="loading"
      @change-page="changePage"
      @on-selection-change="selectItem"
    >
      <Button type="primary" class="mb16 mr8" @click="addPermissions" v-p="{api:'baseRule/addZO'}">添加</Button>
      <Button type="primary" class="mb16" @click="deletePermissions" v-p="{api:'baseRule/delZO'}">删除</Button>
    </table-list>
    </div>
    <add-permissions-modal @refresh="findData(searchData)" :n="addKey" :projectList = "projectList" :empTypeList="empTypeList" :isProjectManager="isProjectManagerList"></add-permissions-modal>
    <update-permissions-modal :n="updateKey"
      @refresh="findData(searchData)"
      :projectList = "projectList"
      :fid="fid"
      :projectFid="projectFid"
      :empTypeList ="empTypeList"
      :pzoName="pzoName"
      :pzoPhone="pzoPhone"
      :pzoDepartment="pzoDepartment"
      :pzoEmpCode ="pzoEmpCode"
      :empType="empType"
      :isProjectManager="isProjectManager"
      :isBeijing="isBeijing"
     ></update-permissions-modal>
    <confirm-modal :n = "deleteKey" :action="`确定删除选中的${permissionsLen}条数据`"  @cancel = "comfirmDeletePermissions"></confirm-modal>

</div>

</template>

<script type="text/ecmascript-6">
import { getAllProjects } from 'api/common'
import { getZOlist, delZO, conditionForZOlist } from 'api/managementCenter'
import SearchList from './components/SearchList';
import TableList from 'components/TableList/index';
import ConfirmModal from 'components/CancelModal/index';
import AddPermissionsModal from './components/AddPermissionsModal';
import UpdatePermissionsModal from './components/UpdatePermissionsModal';
export default {
  name:'permissions',
  components:{
    SearchList,
    TableList,
    ConfirmModal,
    AddPermissionsModal,
    UpdatePermissionsModal
  },
  created(){
    getAllProjects().then(res => {
      this.projectList = res.data
    })
    conditionForZOlist().then( res => {
      this.empTypeList= res.data.zORoleEnums
      this.isProjectManagerList= res.data.isProjectManagerEnums
    })
  },
  computed:{
    permissionsLen(){
      return this.selectedEmps.length
    }
  },
  data () {
    return {
      addKey:0,
      loading:false, // true
      total:0,
      current:1,
      deleteKey:0,
      updateKey:0,
      fids:'',
      searchData:null,
      projectList:[],
      selectedEmps:[],
      empTypeList:[],
      isProjectManagerList:[],
      columns:[
        {
          type: 'selection',
          width: 60,
          align: 'center'
        },
        {
          title:'项目名称',
          key:'projectName',
          align:'center'

        },
        {
          title:'员工姓名',
          key:'pzoName',
          align:'center'

        },
        {
          title:'系统号',
          key:'pzoEmpCode',
          align:'center'

        },
        {
          title:'员工类型',
          key:'empTypeName',
          align:'center'

        },
        {
          title:'虚拟号码',
          key:'pzoXbNumber',
          align:'center'

        },
        {
          title:'真实号码',
          key:'pzoPhone',
          align:'center'
        },{
          title:'操作',
          key:'action',
          align:'center',
          render: (h,params) => {
            return h('a',{
              directives:[
                {
                  name:'p',
                  value:{
                    api:'baseRule/modifyZO'
                  }
                }
              ],
              on:{
                click: () => {
                  this.fid = params.row.fid
                  this.projectFid = params.row.projectFid
                  this.pzoName = params.row.pzoName
                  this.pzoPhone = params.row.pzoPhone
                  this.pzoDepartment = params.row.pzoDepartment
                  this.pzoEmpCode = params.row.pzoEmpCode
                  this.empType = params.row.empType
                  this.isProjectManager = params.row.isProjectManager
                  this.isBeijing = params.row.isBeijing
                  this.updateKey++
                }
              }
            },'修改')
          }
        }
      ],
      tableData:[],
      fid:'',
      projectFid:'',
      pzoName:'',
      pzoPhone:'',
      pzoDepartment:'',
      pzoEmpCode:'',
      empType:0,
      isProjectManager:0,
      isBeijing:false,
    };
 },
 methods:{
    addPermissions(){
      this.addKey++
    },
    changePage(n){
      this.loading  = true
      this.current = n;
      this.searchData.page = n
      this.getList(this.searchData)
    },
    comfirmDeletePermissions(){
      console.log(this.fids)
      delZO(this.fids).then(res => {
        this.$Message.success('删除成功')
        this.findData(this.searchData)
      }).catch(res => {
        console.log(res)
      })
    },
    deletePermissions(){
      if(this.permissionsLen === 0) {
        this.$Message.info('请选择数据！')
      } else {
        this.fids = this.selectedEmps.map( item =>{
          return item.fid
        })
        // this.fids = list.join(',')
        this.deleteKey++
      }
    },
   findData(data){
     this.current = 1
     this.searchData = data
     this.searchData.page = 1
     this.getList(this.searchData)
   },
   getList(data){
     this.loading = true
     getZOlist(data).then(res => {
      this.tableData = res.data.rows
      this.total = res.data.total
       this.isBeijing = res.data.isBeijing
      this.loading = false
     })
   },
   selectItem(selection){
      this.selectedEmps = selection
      console.log(selection)
    },
 }
}
</script>
